"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var AffectationTransformateur_vue_1 = __importDefault(require("./AffectationTransformateur.vue"));
var SourceValueTransfo_1 = __importDefault(require("../../../Transformateur/Mixins/SourceValueTransfo"));
var SourceControlIteration_1 = __importDefault(require("../../Mixins/SourceControlIteration"));
exports.default = vue_1.default.extend({
    props: ['name'],
    mixins: [SourceValueTransfo_1.default, SourceControlIteration_1.default],
    components: { AffectationTransformateur: AffectationTransformateur_vue_1.default }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/SpecificComponents/AffectationsTransformateur.vue
// module id = 206
// module chunks = 0